function waitForElement(selector, trigger, delayInterval, delayTimeout) {
  var interval = setInterval(function () {
    if (
      document &&
      document.querySelector(selector) &&
      document.querySelectorAll(selector).length > 0
    ) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}
function live(selector, event, callback, context) {
  /****Helper Functions****/
  // helper for enabling IE 8 event bindings
  function addEvent(el, type, handler) {
    if (el.attachEvent) el.attachEvent("on" + type, handler);
    else el.addEventListener(type, handler);
  }
  // matches polyfill
  this.Element &&
    (function (ElementPrototype) {
      ElementPrototype.matches =
        ElementPrototype.matches ||
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        function (selector) {
          var node = this,
            nodes = (node.parentNode || node.document).querySelectorAll(selector),
            i = -1;
          while (nodes[++i] && nodes[i] != node);
          return !!nodes[i];
        };
    })(Element.prototype);
  // live binding helper using matchesSelector
  function live(selector, event, callback, context) {
    addEvent(context || document, event, function (e) {
      var found,
        el = e.target || e.srcElement;
      while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
      if (el && found) callback.call(el, e);
    });
  }
  live(selector, event, callback, context);
}
function quantityCounter() {
      var countElement = document.getElementById("count");
      var count = 0;

      var decreaseBtn = document.getElementById("decreaseBtn");
      decreaseBtn.addEventListener("click", decrease);

      var increaseBtn = document.getElementById("increaseBtn");
      increaseBtn.addEventListener("click", increase);

      function decrease() {
        if (count > 1) {
          count--;
          countElement.textContent = count;
        }
      }

      function increase() {
        count++;
        countElement.textContent = count;
      }
    }
function changeImage() {
      document.querySelector(".product-bundle__content .product-bundle__image").innerHTML = `<img src="${orImage}"/>`;
      document.querySelectorAll(".swatchBundleItems .eg-swatch-clrs .swatch-element").forEach((changeSwatch) => {
        changeSwatch.addEventListener("click", function () {
            const ImageValue = this.querySelector("input").value;
            let imageURL = orImage;
            if(ImageValue == 'Silver'){
                imageURL = argentImage;
            }else if(ImageValue == 'Rose Gold'){
                imageURL = roseGoldImage;
            }else if(ImageValue == 'Gold'){
                imageURL = orImage;
            }
          document.querySelector(".product-bundle__content .product-bundle__image").innerHTML = `<img src="${imageURL}"/>` ;
        })
      })
    }
const addToBagGift = (qty, pID) => {
      fetch("https://mylittlenecklace.com.mx/cart/add.js", {
        "headers": {
          "accept": "application/json, text/javascript, */*; q=0.01",
          "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-origin",
          "x-requested-with": "XMLHttpRequest"
        },
        "body": `quantity=${qty}&id=${pID}`,
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
      }).then((res) => {
        console.log("gift added to cart");
      })
    }
 live(['.template-collection .MainProductSwatch .swatch-element label', '.template-index .MainProductSwatch .swatch-element label', '.eg-request-el .swatch-element label'], 'click', function () {
    const imgEl = this.closest(".product-block__link").querySelector(".rimage__image");
  console.log(this.parentElement.querySelector("input"));
    if ((this.parentElement.querySelector("input")) && (this.parentElement.querySelector("input").getAttribute("data-image-src").indexOf("gif") == -1)) {
       console.log(imgEl);
      imgEl.src = this.parentElement.querySelector("input").getAttribute("data-image-src").replace("small", "540x");
      imgEl.setAttribute("srcset", this.parentElement.querySelector("input").getAttribute("data-image-src").replace("small", "540x"));
       console.log(imgEl);
    }
    this.closest(".swatch-element").parentElement.querySelector(".swatch-element.active") && this.closest(".swatch-element").parentElement.querySelector(".swatch-element.active").classList.remove("active");
    this.closest(".swatch-element").classList.add("active");
  });

jQuery(document).ready(function($){
  
  const title = $(".MainProductSwatchLength .MnSwatchLengthHeader .header").text();
  if(title.match("Chain Length") || title.match("Longitud de la cadena")){
    document.body.classList.add("eg-pdp");
  }
live('.eg-clr-circle', 'click', function () {
      this.parentElement.querySelector("label") && this.parentElement.querySelector("label").click();
    });
   waitForElement(".product-bundle__items  .swatch:nth-of-type(2) .header", function () {
        document.querySelector(".product-bundle__items  .swatch:nth-of-type(2) .header").innerText = "Longitud";
      }, 50, 15000);
   waitForElement(".product-bundle__items .swatch:nth-of-type(2) .swatch-element label", function () {
        var labels = document.querySelectorAll('.product-bundle__items .swatch:nth-of-type(2) .swatch-element label');
        for (var i = 0; i < labels.length; i++) {
          var labelText = labels[i].textContent.split("|")[0];
          labelText = labelText.replace(/\s/g, '');
          labelText = labelText.replace('cm-', '-');
          labels[i].textContent = labelText;
        }
      }, 1000, 15000);
  waitForElement(".eg-pdp .VariantOptionsLengthmn", function () {
        var labels = document.querySelectorAll('.eg-pdp .VariantOptionsLengthmn .variantName');
        for (var i = 0; i < labels.length; i++) {
          var labelText = labels[i].textContent.split("|")[0];
          labelText = labelText.replace(/\s/g, '');
          labelText = labelText.replace('cm-', '-');
          labels[i].textContent = labelText;
        }
      }, 1000, 15000);

    waitForElement(".product-bundle__wrapper > .product-bundle__content h3", function () {
        if (document.querySelector(".product-bundle__wrapper > .product-bundle__content h3")) {
          //document.querySelector(".product-bundle__wrapper > .product-bundle__content h3").innerText = "Offrez-en un deuxième en cadeau !";
        }
      }, 100, 25000);
  waitForElement(".gift_products_inner .cv__product_price", function () {
        quantityCounter();
      }, 100, 25000);
  waitForElement(".product-bundle__content .product-bundle__image", changeImage, 100, 15000);
   waitForElement(".gift_products_inner .product-bundle__image_gift img", function () {
        document.querySelector(".gift_products_inner .product-bundle__image_gift img").setAttribute("src", giftImage);
      }, 100, 15000);
  waitForElement(".gift_products_outer .product-bundle__info h3", function () {
        if (document.querySelector(".gift_products_outer .product-bundle__info h3")) {
          //document.querySelector(".gift_products_outer .product-bundle__info h3").innerText = "Ajoutez une boîte cadeau";
        }
      }, 50, 15000);

  live(".product-bundle__atc", "click", function () {
      const giftBx = document.querySelector(".gift_repeated");
      const checkBx = giftBx.querySelector("#giftboxmsg");
      if (checkBx && checkBx.checked) {
        waitForElement(".ajax-cart__drawer.is-open", function () {
          waitForElement("#giftpro", function () {
            const gId = document.querySelector("#giftpro").getAttribute("value");
            const gQty = Number(giftBx.querySelector(".eg-counter > #count").innerText.trim()) - 1;
            if(document.querySelectorAll(`.ajax-cart-item__info[data-id="${gId}"]`).length > 0){
              document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__image").src = cartGiftImage;
              
            }
            addToBagGift(gQty, gId);
            // updating value in cart
            setTimeout(() => {
              fetch("https://mylittlenecklace.com/cart").then(res => {
                const html = res.text();
                return html;
              }).then(html => {
                const el = document.createElement("div");
                el.innerHTML = html;
                const product = el.querySelector(`.cart-item .cart-item-description a[href*="${gId}"]`).closest(".cart-item").querySelector('.quantity-adjuster__input');
                if (product) {
                  document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__input-quantity").value = product.value;
                  console.log("value updated to new ", product.value);
                  document.querySelector(`.ajax-cart-item__info[data-id="${gId}"]`).parentElement.querySelector(".ajax-cart-item__image").src = cartGiftImage;
                }
              })
            }, 1300);
          }, 50, 15000);
        }, 50, 15000);
      }
    });
  
  $('input[name="bundle_selc"]').change(function(e){
    var id = $(this).attr('data-id');
    var img = $(this).attr('data-image-src');
    setTimeout(function(){ 
      $('#bundleForm [name="id"]').val(id); 
      $('.product-bundle__image img').attr('src', img);
    },200);
  });

  $('.product-bundle__selc').click(function(){             
    $('#bundleProduct').attr('checked',this.checked);
    $('.product-bundle__properties').toggle(this.checked);
    if(this.checked == true){        
      $('#product-bundle-price').html($('#product-bundle-price').attr('data-bundleprice'));
    }else{                
      $('#product-bundle-price').html($('#product-bundle-price').attr('data-price'));
    }
  });

  $(document).on('change  paste','.option-type-text.option-required input',function(e){
    var titles = [];            
    $('.option-type-text.option-required input').each(function(){
      if ($(this).val()) {
        titles.push($(this).val());
      }
    }); 
    $('#mainProduct').attr('data-prop',titles);
  });

  $('#product-bundle__prop').on('change keyup paste',function(){
    $('#bundleProduct').attr('data-prop',$(this).val());
    $('#bundleText').attr('data-prop',$(this).val());
    $('#bundleText').val($(this).val()).change();
  });

  $('#SingleOptionSelector-0').change(function(){
    setTimeout(function(){
      $('#mainProduct').attr('data-id',$('[data-product-select]').val());
    },200);      
  });
  $('#select2-quantity-proxy-container').on('DOMSubtreeModified',function(){
    setTimeout(function(){
      $('#mainProduct').attr('data-qty',$(this).html());
    },200);
  });      

  $('.product-bundle__title').click(function(){
    $(this).parents('.product-bundle__item').siblings().removeClass('Cv_Active_Item');
    $(this).parents('.product-bundle__item').addClass('Cv_Active_Item');
  });
});
$(document).ready(function(){
  $(document).on("click",'.faqs-item',function() {
      $(this).toggleClass('active');
      $(this).find('.faqs-item-content').slideToggle('fast');
    });
   $(document).on("click",'.custom-accordian-wrapper',function() {
      $(this).toggleClass('active');
      $(this).find('.custom-accordian-content').slideToggle('fast');
    });
  setInterval(function(){
    $('.js-ajax-cart-drawer-content').children('.ajax-cart-item__single').each(function(){
      if( $(this).children('.ajax-cart-item__info').children('.ajax-cart-drawer__line-item.date').length > 0 ){
        var dateVal = $(this).children('.ajax-cart-item__info').children('.ajax-cart-drawer__line-item.date').html();
        dateVal = dateVal.split('</span>')[1];
        var TextVal = $(this).children('.ajax-cart-item__info').children('.ajax-cart-drawer__line-item.text').html();
        TextVal = TextVal.toString().replace(/"/g, "");
        TextVal = TextVal.split('</span>')[1];
        if( TextVal.indexOf("/") != -1   ){
        }
        else{
          $(this).children('.ajax-cart-item__info').children('.ajax-cart-drawer__line-item.text').append(','+dateVal);
          $(this).children('.ajax-cart-item__info').children('.ajax-cart-drawer__line-item.date').remove()
        }
      }
    });
  },500);



  if ($(window).width() < 769) {
    $('.mobile-image-slider').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows:true,
      dots:false
    });
  }
  else {
  }
});


$('[data-option-index="0"]').children('.swatch-element').children('input').click(function(){
  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="1"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="2"]').children('.swatch-element').children('input:checked').attr('value');

  if( $('[data-option-index="2"]').length > 0 ){
    var concatVal = objectTitle+' / '+optionedCheckedValue+' / '+SecondoptionedCheckedValue;
  }
  else if( $('[data-option-index="1"]').length > 0 ){
    var concatVal = objectTitle+' / '+optionedCheckedValue;
  }
  else{
    var concatVal = objectTitle;
  }

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Color' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).html();
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false;
    }
  }); 

});

$('[data-option-index="1"]').children('.swatch-element').children('input').click(function(){

  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="0"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="2"]').children('.swatch-element').children('input:checked').attr('value');

  if( $('[data-option-index="2"]').length > 0 ){ 
    var concatVal = optionedCheckedValue+' / '+objectTitle+' / '+SecondoptionedCheckedValue;
  }
  else{
    var concatVal = optionedCheckedValue+' / '+objectTitle;
  }

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Color' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).text();
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false;
    }
  }); 

}); 

$('[data-option-index="2"]').children('.swatch-element').children('input').click(function(){
  var ObjectSwatch = $(this).attr('data-title');
  var objectTitle = $(this).attr('value');
  var ObjectId = $(this).attr('data-id');
  var optionedCheckedValue = $('[data-option-index="0"]').children('.swatch-element').children('input:checked').attr('value');
  var SecondoptionedCheckedValue = $('[data-option-index="1"]').children('.swatch-element').children('input:checked').attr('value');
  var concatVal = optionedCheckedValue+' / '+SecondoptionedCheckedValue+' / '+objectTitle;

  $(this).parents('.swatch-element').addClass('Cv_Active_Item').siblings().removeClass('Cv_Active_Item');
  if( ObjectSwatch == 'Color' ){
    var ObjectImage = $(this).attr('data-image-src');
    $(this).parents('.product-bundle__wrapper').children('.product-bundle__content').children('.product-bundle__image').children('img').attr('src',ObjectImage);
  }

  $(this).parents('.swatchBundleItems').children('.HiddenVariant').children('li').each(function(){
    var dataName = $(this).attr('data-name');
    if( concatVal == dataName){
      var GoiId = $(this).html();
      $('#bundleForm').children('[name="id"]').val(GoiId);
      return false; 
    } 
  }); 
});     

$(document).ready(function(){
$(document).on("click",".main-nav__child-item.main-nav__child-has-dropdown.eg-click-added", function(){
    $(this).addClass("show-dropdown");
  });
   $(document).on("click",".main-nav__child-item.main-nav__child-has-dropdown.eg-click-added.show-dropdown", function(){
    $(this).removeClass("show-dropdown");
  });
  $('[lengthDefaultObject]').click(function(){
    $(this).parents('.LengthCollectiveObject').toggleClass('length-active');
    $(this).parents('.LengthCollectiveObject').children('.VariantOptionsLengthmn').toggleClass('show-dropdown');
  });

  var LengthVariant = document.querySelectorAll('.VariantOptionsLengthmn li');
  for (var i = 0; i < LengthVariant.length; i++) {
    LengthVariant[i].addEventListener('click', function(event) {
      $(this).addClass('active').siblings().removeClass('active');
      $(this).parents('.LengthCollectiveObject').removeClass('length-active');
      $(this).parents('.VariantOptionsLengthmn').removeClass('show-dropdown');
      var HtmlOfLi = $(this).children('.variantName').html();
      var HtmlOfmg = $(this).children('.variantImg').children('img').attr('src');
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('img').attr('src',HtmlOfmg);
      $(this).parents('.LengthCollectiveObject').children('.defaultVariantmn').children('[lengthdefaultobject]').children('[type="text"]').val(HtmlOfLi);
      var optionIndex = event.target.closest('.MainProductSwatchLength').getAttribute('main-option-index');
      var optionValue = $(this).children('.variantOrignalName').html();
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });
  }

  var Colorvariants = document.querySelectorAll('[main-option-index="0"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    });    
  }
  
  if( $('.VariantOptionsLengthmn').length != 1 ){
    console.log('length-active')
    var Colorvariants = document.querySelectorAll('[main-option-index="1"] input[type=radio]');
    for (var i = 0; i < Colorvariants.length; i++) {
      Colorvariants[i].addEventListener('click', function(event) {
        $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
        var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
        var optionValue = event.target.value;
        var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
        trig.value = optionValue;
        var event = new Event('change');
        trig.dispatchEvent(event);
      }); 
    }
  }
  
  var Colorvariants = document.querySelectorAll('[main-option-index="2"] input[type=radio]');
  for (var i = 0; i < Colorvariants.length; i++) {
    Colorvariants[i].addEventListener('click', function(event) {
      $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
      var optionIndex = event.target.closest('.swatch').getAttribute('main-option-index');
      var optionValue = event.target.value;
      var trig = event.target.closest('form').querySelector('#SingleOptionSelector-'+optionIndex);
      trig.value = optionValue;
      var event = new Event('change');
      trig.dispatchEvent(event);
    }); 
  }
 
});


$(document).on('click','.CaptureLengthPopup', function(e){
  $(this).parents('.product-form').find('.LengthSizeImagePopup').addClass('active');
  $('body').addClass('LengthPopupMasked');
})


$(document).click(function (e) { 
  if (!$(e.target).closest('.LengthSizeImagePopup.active, .CaptureLengthPopup').length) {
    $('.LengthSizeImagePopup').removeClass('active');
    $('body').removeClass('LengthPopupMasked');
  }
});